<h2 mat-dialog-title>Create Variant</h2>

<mat-dialog-content>

  <!-- Variant Key Select -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Variant Key</mat-label>

    <mat-select [(ngModel)]="variant_key" name="variant_key">
  
  <mat-select-trigger>
    {{ getDisplayNameForKey(variant_key) }}
  </mat-select-trigger>

      <mat-option *ngFor="let key of variantStore.variantKeys()" 
                  [value]="key.key_code">

        <div class="option-row">
          <span>{{ key.display_name }}</span>

          <button mat-icon-button color="warn"
                  (click)="deleteVariantKey(key); $event.stopPropagation()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </mat-option>

      <!-- Create New Key Button -->
      <mat-option class="create-new-option"
                  (click)="openCreateVariantKeyDialog()">
        <mat-icon>add</mat-icon>
        <span>Create New Variant Key</span>
      </mat-option>

    </mat-select>
  </mat-form-field>

  <!-- Price -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Price</mat-label>
    <input matInput type="number" [(ngModel)]="price" />
  </mat-form-field>

  <!-- Attributes -->
  <h4>Attributes</h4>

  <div *ngFor="let attr of attributes; let i = index" class="attribute-row">
    <mat-form-field>
      <mat-label>Key</mat-label>
      <input matInput [(ngModel)]="attr.key" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Value</mat-label>
      <input matInput [(ngModel)]="attr.value" />
    </mat-form-field>

    <button mat-icon-button color="warn" (click)="removeAttribute(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <button mat-stroked-button (click)="addAttributeField()">Add Attribute</button>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Create</button>
</mat-dialog-actions>
